import config from '../config';
import { auth_fetch, checkSuccess, PayloadError } from './ajax';

export type VoteEligibility = {
    cellId: number;
    eligible: boolean;
    reason: 'open' | 'existing_vote' | 'honeypot' | 'cell_complete' | 'outside_policy';
};

export async function fetchVoteEligibility(cellId: number, annotatorId: number, signal?: AbortSignal): Promise<VoteEligibility> {
    return auth_fetch(`${config.backend}/api/cell_vote_eligibility/`, {
        method: 'POST', signal,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cellId, annotatorId }),
    }).then(checkSuccess);
}

export async function isCompletedVoteError(error: unknown): Promise<boolean> {
    if (!(error instanceof PayloadError)) return false;
    try { return (await error.payload)?.code === 'cell_complete'; }
    catch { return false; }
}

// A deleted stored visit is different from a retryable eligibility failure.
export async function isMissingCellError(error: unknown): Promise<boolean> {
    if (!(error instanceof PayloadError)) return false;
    try { return (await error.payload)?.detail === 'Cell does not exist'; }
    catch { return false; }
}

// Resolve relative navigation by identity, even when completed pending cells
// have disappeared or newly cast votes moved into the history prefix.
export function nextQueueIndex(oldQueue: number[], freshQueue: number[], currentId: number, direction: number): number {
    const oldIndex = oldQueue.indexOf(currentId);
    for (let index = oldIndex + direction; index >= 0 && index < oldQueue.length; index += direction) {
        const freshIndex = freshQueue.indexOf(oldQueue[index]);
        if (freshIndex >= 0) return freshIndex;
    }
    return -1;
}
